import { Trans as TransComponent, useLingui } from '@lingui/react';
import { Trans as _Trans } from "@lingui/react";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useFeatures } from '@wkda/feature-toggle';
import { Footer, Header } from '@wkda/styleguide';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import { DataLayerScript } from '../DataLayerScript';
import EmailSubscription from '../EmailSubscription';
import { GDPRBanner } from '../GDPRBanner';
import { CookieBanner, CovidBanner } from '../InformationBanners';
import { ModalManager } from '../ModalManager';
import { useAppConfiguration } from '../hooks/useAppConfiguration';
import useAuthState from '../hooks/useAuthState';
import { useLayoutQuery, useSubscribeToNewsletter } from '../hooks/useDataHooks';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Layout(_ref) {
  let {
    children,
    customBanner: CustomBanner,
    customGDPRBanner,
    containerClassName = 'container',
    emailSubscriptionClassName = 'mb-3',
    modernLayout = false,
    emailSubscriptionExcluded = false
  } = _ref;
  const {
    i18n
  } = useLingui();
  const location = useLocation();
  const termsLinkTarget = i18n._({
    id: 'emailSubscriptionWidget.description.termsTarget'
  });
  const privacyLinkTarget = i18n._({
    id: 'emailSubscriptionWidget.description.privacyTarget'
  });
  const {
    status: subscribeStatus,
    mutateAsync
  } = useSubscribeToNewsletter();
  const {
    data,
    status
  } = useLayoutQuery();
  const {
    emailSubscription
  } = useFeatures();
  const {
    loginItem,
    loggedInItem,
    isAuthValid,
    hasCustomerAccount
  } = useAuthState();
  const {
    fullLocale
  } = useAppConfiguration();
  if (status !== 'success') {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DataLayerScript, {}), /*#__PURE__*/_jsxs(ModalManager.Provider, {
      children: [/*#__PURE__*/_jsx(GDPRBanner, {
        customGDPRBanner: customGDPRBanner
      }), /*#__PURE__*/_jsxs("div", {
        className: `sticky-footer main-content-area locale-${fullLocale.toLowerCase()} ${hasCustomerAccount ? 'has-customer-account' : 'no-customer-account'}`,
        children: [/*#__PURE__*/_jsx(CookieBanner, {}), /*#__PURE__*/_jsx(Header, {
          ...data.header.data,
          MenuText: /*#__PURE__*/_jsx(_Trans, {
            id: "selfInspection.header.menuLabel",
            message: "Men\xFC"
          }),
          LinkComponent: 'a',
          pageUrl: location.pathname,
          hasUserAccount: hasCustomerAccount,
          userIsLoggedIn: isAuthValid,
          userNavList: data.headerUserNavList.data,
          loginItem: loginItem,
          loggedInItem: loggedInItem
        }), /*#__PURE__*/_jsx(CovidBanner, {}), CustomBanner && /*#__PURE__*/_jsx(CustomBanner, {}), /*#__PURE__*/_jsxs("div", {
          className: cx('main-body-container', containerClassName),
          children: [children, emailSubscriptionExcluded || emailSubscription && /*#__PURE__*/_jsx("div", {
            className: cx('subscription-container', emailSubscriptionClassName),
            children: /*#__PURE__*/_jsx(EmailSubscription, {
              mainTitle: i18n._('emailSubscriptionWidget.title'),
              mainSubtitle: i18n._('emailSubscriptionWidget.secondaryText'),
              successMessageDesktop: i18n._('emailSubscriptionWidget.successMessageDesktop'),
              successMessageMobile: i18n._('emailSubscriptionWidget.successMessageMobile'),
              invalidEmailErrorMessage: i18n._('selfInspection.error.email'),
              emailFieldPlaceholder: i18n._('emailSubscriptionWidget.form.email.placeholder'),
              emailFieldLabel: i18n._('emailSubscriptionWidget.form.email.placeholder'),
              submitButtonText: i18n._('emailSubscriptionWidget.form.button.submit'),
              contentDescription: /*#__PURE__*/_jsx(TransComponent, {
                id: "emailSubscriptionWidget.description",
                components: {
                  termsLink:
                  /*#__PURE__*/
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  _jsx("a", {
                    href: termsLinkTarget,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "email-subscription__desc-link"
                  }),
                  privacyLink:
                  /*#__PURE__*/
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  _jsx("a", {
                    href: privacyLinkTarget,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "email-subscription__desc-link"
                  })
                }
              }),
              status: subscribeStatus,
              onSubmitHandler: mutateAsync
            })
          })]
        }), modernLayout === true ? /*#__PURE__*/_jsx(Footer, {
          ...data.footer.data
        }) : null]
      }), modernLayout === false ? /*#__PURE__*/_jsx(Footer, {
        ...data.footer.data
      }) : null]
    }), /*#__PURE__*/_jsx(ReactQueryDevtools, {})]
  });
}